import React, { useState, useEffect } from 'react';
import api from '../api';
import toast from 'react-hot-toast';
import { exportCSV } from '../utils/exportCSV';

function downloadSampleCSV() {
  const rows = [
    ['name', 'number', 'city', 'comments'],
    ['Rahul Sharma', '9876543210', 'Mumbai', 'Interested in premium plan'],
    ['Priya Patel', '9123456780', 'Delhi', 'Follow up required'],
    ['Amit Verma', '9988776655', 'Bangalore', 'Wants product demo'],
    ['Sneha Gupta', '9871234560', 'Pune', 'Small business owner'],
    ['Vikram Singh', '9765432100', 'Hyderabad', ''],
  ];
  const csv = rows.map(r => r.map(c => `"${c}"`).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = 'sample_calling_data.csv'; a.click(); URL.revokeObjectURL(url);
}

export default function CallingData() {
  const [data, setData] = useState([]);
  const [batches, setBatches] = useState([]);
  const [users, setUsers] = useState([]);
  const [calledByMap, setCalledByMap] = useState({});
  const [showUpload, setShowUpload] = useState(false);
  const [showAssign, setShowAssign] = useState(false);
  const [showReassign, setShowReassign] = useState(false);
  const [reassignLead, setReassignLead] = useState(null);
  const [reassignUser, setReassignUser] = useState('');
  const [file, setFile] = useState(null);
  const [batchName, setBatchName] = useState('');
  const [assignedTo, setAssignedTo] = useState('');
  const [uploading, setUploading] = useState(false);
  const [filterBatch, setFilterBatch] = useState('');
  const [filterDNC, setFilterDNC] = useState(false);
  const [assignBatch, setAssignBatch] = useState('');
  const [assignUser, setAssignUser] = useState('');

  useEffect(() => {
    fetchData();
    api.get('/calling/batches').then(r => setBatches(r.data));
    api.get('/users').then(r => setUsers(r.data));
  }, []);

  const fetchData = () => {
    api.get('/calling/all').then(r => setData(r.data));
    api.get('/leads/called-by').then(r => setCalledByMap(r.data));
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return toast.error('Select a CSV file');
    setUploading(true);
    const fd = new FormData();
    fd.append('file', file);
    fd.append('batchName', batchName || `Batch_${Date.now()}`);
    if (assignedTo) fd.append('assignedTo', assignedTo);
    try {
      const { data: res } = await api.post('/calling/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success(res.message);
      setShowUpload(false); setFile(null); setBatchName(''); setAssignedTo('');
      fetchData();
      api.get('/calling/batches').then(r => setBatches(r.data));
    } catch (err) {
      toast.error(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  const handleAssign = async (e) => {
    e.preventDefault();
    try {
      await api.put('/calling/assign', { batchName: assignBatch, assignedTo: assignUser || null });
      toast.success('Batch assigned');
      setShowAssign(false);
      fetchData();
    } catch (e) {
      toast.error('Failed');
    }
  };

  const deleteLead = async (leadId, name) => {
    if (!window.confirm(`Delete lead "${name}"? This cannot be undone.`)) return;
    try {
      await api.delete('/calling/' + leadId);
      toast.success('Lead deleted');
      fetchData();
    } catch (e) { toast.error('Failed to delete'); }
  };

  const deleteBatch = async (batchName) => {
    if (!window.confirm(`Delete entire batch "${batchName}" and all its leads? This cannot be undone.`)) return;
    try {
      const { data: res } = await api.delete('/calling/batch/' + encodeURIComponent(batchName));
      toast.success(res.message);
      fetchData();
      api.get('/calling/batches').then(r => setBatches(r.data));
    } catch (e) { toast.error('Failed to delete batch'); }
  };

  const handleReassign = async (e) => {
    e.preventDefault();
    try {
      await api.put('/leads/reassign/' + reassignLead._id, { assignedTo: reassignUser || null });
      toast.success('Lead reassigned');
      setShowReassign(false);
      setReassignLead(null);
      fetchData();
    } catch (e) { toast.error('Failed to reassign'); }
  };

  const removeDNC = async (leadId) => {
    try {
      await api.put('/leads/undnc/' + leadId);
      toast.success('DNC removed');
      fetchData();
    } catch (e) { toast.error('Failed'); }
  };

  const filtered = filterBatch ? data.filter(d => d.batchName === filterBatch) : data;
  const filteredFinal = filterDNC ? filtered.filter(d => d.dnc) : filtered.filter(d => !d.dnc);
  const userMap = Object.fromEntries(users.map(u => [u._id, u]));

  return (
    <div className="fadein">
      <div className="page-header">
        <div>
          <div className="page-title">Calling Data</div>
          <div className="page-subtitle">{data.length} records · {batches.length} batches</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => setShowAssign(true)}>Assign Batch</button>
          <button className="btn btn-secondary btn-sm" onClick={() => {
            const rows = filtered.map(d => ({
              Name: d.name,
              Phone: d.number,
              City: d.city || '',
              Comments: d.comments || '',
              Batch: d.batchName || '',
              'Call Status': calledByMap[d._id]?.status || 'not called',
              'Called By': calledByMap[d._id]?.calledBy || ''
            }));
            exportCSV('calling_data.csv', rows, ['Name', 'Phone', 'City', 'Comments', 'Batch', 'Call Status', 'Called By']);
          }}>Export CSV</button>
          <button className="btn btn-secondary btn-sm" onClick={() => setShowAssign(true)}>Assign Batch</button>
          {filterBatch && (
            <button className="btn btn-xs btn-danger" onClick={() => deleteBatch(filterBatch)}>Delete Batch</button>
          )}
          <button className="btn btn-primary btn-sm" onClick={() => setShowUpload(true)}>Upload CSV</button>
        </div>
      </div>

      {/* Summary stat cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 16 }}>
        {[
          { label: 'Total Records', value: data.length },
          { label: 'Batches',       value: batches.length },
          { label: 'Called',        value: Object.keys(calledByMap).length },
        ].map(s => (
          <div key={s.label} className="stat-card">
            <div style={{ fontSize: 24, fontWeight: 700, color: 'var(--text-1)', lineHeight: 1 }}>{s.value}</div>
            <div style={{ fontSize: 12.5, color: 'var(--text-3)', marginTop: 5 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Batch filter */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 12, alignItems: 'center' }}>
        <select value={filterBatch} onChange={e => setFilterBatch(e.target.value)} style={{ width: 'auto', minWidth: 200 }}>
          <option value="">All Batches</option>
          {batches.map(b => <option key={b} value={b}>{b}</option>)}
        </select>
        {filterBatch && <button className="btn btn-ghost btn-sm" onClick={() => setFilterBatch('')}>Clear</button>}
        <button className="btn btn-sm" onClick={() => setFilterDNC(!filterDNC)}
          style={{ background: filterDNC ? '#fff5f5' : '#fff', color: filterDNC ? '#c92a2a' : '#4b5263', border: `1px solid ${filterDNC ? '#ffc9c9' : '#e2e5ef'}` }}>
          {filterDNC ? 'Showing DNC' : 'Show DNC'}
        </button>
        <span style={{ fontSize: 12.5, color: 'var(--text-3)', marginLeft: 'auto' }}>{filteredFinal.length} records</span>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Phone</th>
              <th>City</th>
              <th>Comments</th>
              <th>Batch</th>
              <th>Assigned To</th>
              <th>Call Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredFinal.slice(0, 100).map((d, i) => {
              const ci = calledByMap[d._id];
              return (
                <tr key={d._id} style={d.dnc ? { opacity: 0.55 } : {}}>
                  <td style={{ color: 'var(--text-3)', fontSize: 12 }}>{i + 1}</td>
                  <td style={{ fontWeight: 500 }}>
                    {d.dnc && <span style={{ fontSize: 10, background: '#fff5f5', color: '#c92a2a', border: '1px solid #ffc9c9', borderRadius: 3, padding: '1px 5px', marginRight: 6 }}>DNC</span>}
                    {d.name}
                  </td>
                  <td>
                    <a href={`tel:${d.number}`} style={{ color: 'var(--accent)', textDecoration: 'none', fontSize: 13 }}>{d.number}</a>
                  </td>
                  <td style={{ color: 'var(--text-3)' }}>{d.city || '—'}</td>
                  <td style={{ color: 'var(--text-3)', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.comments || '—'}</td>
                  <td>
                    <span style={{ fontSize: 12, background: 'var(--accent-dim)', color: 'var(--accent)', padding: '2px 7px', borderRadius: 'var(--r-xs)', border: '1px solid var(--accent-border)' }}>
                      {d.batchName}
                    </span>
                  </td>
                  <td style={{ fontSize: 13 }}>
                    {d.assignedTo && userMap[d.assignedTo]
                      ? userMap[d.assignedTo].name
                      : <span style={{ color: 'var(--text-3)' }}>All</span>}
                  </td>
                  <td>
                    {ci ? (
                      <div>
                        <span className={`badge badge-${ci.status}`}>{ci.status.replace(/_/g, ' ')}</span>
                        <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 2 }}>by {ci.calledBy}</div>
                      </div>
                    ) : <span style={{ fontSize: 12, color: 'var(--text-3)' }}>—</span>}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 5 }}>
                      <button className="btn btn-xs btn-secondary" onClick={() => { setReassignLead(d); setReassignUser(d.assignedTo || ''); setShowReassign(true); }}>
                        Reassign
                      </button>
                      {d.dnc && (
                        <button className="btn btn-xs" onClick={() => removeDNC(d._id)}
                          style={{ background: '#ebfbee', color: '#2f9e44', border: '1px solid #b2f2bb', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}>
                          Remove DNC
                        </button>
                      )}
                      <button className="btn btn-xs btn-danger" onClick={() => deleteLead(d._id, d.name)}>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {filteredFinal.length === 0 && (
              <tr><td colSpan={9}><div className="empty"><div className="empty-icon"></div><p>No records</p></div></td></tr>
            )}
          </tbody>
        </table>
        {filteredFinal.length > 100 && (
          <div style={{ padding: '10px 14px', fontSize: 12.5, color: 'var(--text-3)', borderTop: '1px solid var(--border-light)' }}>
            Showing 100 of {filteredFinal.length}
          </div>
        )}
      </div>

      {/* Upload modal */}
      {showUpload && (
        <div className="modal-overlay" onClick={() => setShowUpload(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <h2>Upload CSV</h2>
              <button className="modal-close" onClick={() => setShowUpload(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ background: 'var(--accent-dim)', border: '1px solid var(--accent-border)', borderRadius: 'var(--r)', padding: '10px 14px', marginBottom: 16, fontSize: 13 }}>
                <div style={{ color: 'var(--accent)', marginBottom: 8 }}>Required columns: <strong>name, number, city, comments</strong></div>
                <button type="button" onClick={downloadSampleCSV} className="btn btn-secondary btn-sm">Download Sample</button>
              </div>
              <form onSubmit={handleUpload}>
                <div className="form-group">
                  <label>CSV File</label>
                  <input type="file" accept=".csv" onChange={e => setFile(e.target.files[0])} required />
                </div>
                <div className="form-group">
                  <label>Batch Name</label>
                  <input value={batchName} onChange={e => setBatchName(e.target.value)} placeholder="e.g. May 2024 Leads" />
                </div>
                <div className="form-group">
                  <label>Assign To</label>
                  <select value={assignedTo} onChange={e => setAssignedTo(e.target.value)}>
                    <option value="">All employees</option>
                    {users.map(u => <option key={u._id} value={u._id}>{u.name} ({u.role})</option>)}
                  </select>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button className="btn btn-primary" type="submit" disabled={uploading} style={{ flex: 1 }}>
                    {uploading ? 'Uploading...' : 'Upload'}
                  </button>
                  <button className="btn btn-secondary" type="button" onClick={() => setShowUpload(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Assign modal */}
      {showAssign && (
        <div className="modal-overlay" onClick={() => setShowAssign(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <h2>Assign Batch</h2>
              <button className="modal-close" onClick={() => setShowAssign(false)}>✕</button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleAssign}>
                <div className="form-group">
                  <label>Batch</label>
                  <select value={assignBatch} onChange={e => setAssignBatch(e.target.value)} required>
                    <option value="">Select batch</option>
                    {batches.map(b => <option key={b} value={b}>{b}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Assign To</label>
                  <select value={assignUser} onChange={e => setAssignUser(e.target.value)}>
                    <option value="">All employees</option>
                    {users.map(u => <option key={u._id} value={u._id}>{u.name} ({u.role})</option>)}
                  </select>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button className="btn btn-primary" type="submit" style={{ flex: 1 }}>Assign</button>
                  <button className="btn btn-secondary" type="button" onClick={() => setShowAssign(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Reassign modal */}
      {showReassign && reassignLead && (
        <div className="modal-overlay" onClick={() => setShowReassign(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <h2>Reassign Lead</h2>
              <button className="modal-close" onClick={() => setShowReassign(false)}>✕</button>
            </div>
            <div className="modal-body">
              <p style={{ fontSize: 13, color: 'var(--text-2)', marginBottom: 14 }}>
                Reassign <strong>{reassignLead.name}</strong> ({reassignLead.number}) to a different employee.
              </p>
              <form onSubmit={handleReassign}>
                <div className="form-group">
                  <label>Assign To</label>
                  <select value={reassignUser} onChange={e => setReassignUser(e.target.value)}>
                    <option value="">Available to all employees</option>
                    {users.map(u => <option key={u._id} value={u._id}>{u.name} ({u.role})</option>)}
                  </select>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button className="btn btn-primary" type="submit" style={{ flex: 1 }}>Reassign</button>
                  <button className="btn btn-secondary" type="button" onClick={() => setShowReassign(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
